export enum CdnTypeEnum {
  Public = 0,
  Private = 1
}
